import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormControl, Select, MenuItem, Box } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';

const languages = [
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Español' },
];

export default function LanguageSwitcher({ compact = false }) {
  const { i18n, t } = useTranslation('common');

  const handleChange = (event) => {
    const newLang = event.target.value;
    i18n.changeLanguage(newLang);
    // Persist to localStorage (i18next-browser-languagedetector does this, but we ensure it)
    localStorage.setItem('i18nextLng', newLang);
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <LanguageIcon sx={{ color: 'text.secondary', fontSize: compact ? 20 : 24 }} />
      <FormControl size="small" sx={{ minWidth: compact ? 100 : 120 }}>
        <Select
          value={i18n.language?.split('-')[0] || 'en'}
          onChange={handleChange}
          displayEmpty
          sx={{
            '& .MuiSelect-select': {
              py: compact ? 0.5 : 1,
              fontSize: compact ? '0.875rem' : '1rem',
            },
          }}
        >
          {languages.map((lang) => (
            <MenuItem key={lang.code} value={lang.code}>
              {lang.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}
